export { getArticleIcon };

function getArticleIcon(article, options = { tooltip: false }) {
  const articleType =
    article && article.template ? article.template : 'generic';
  const articleSubType = article && article.subtype ? article.subtype : '';
  //You can add a mini switch for subtypes, defaulting to the template's general icon (default case);
  let icon = '';
  let tooltip = '';
  switch (articleType) {
    case 'landmark':
      icon = 'ra ra-pyramids';
      break;
    case 'person':
      icon = 'ra ra-player';
      break;
    case 'condition':
      icon = 'ra ra-biohazard';
      break;
    case 'militaryConflict':
      icon = 'ra ra-dripping-sword';
      break;
    case 'organization':
      icon = 'ra ra-cog';
      break;
    case 'document':
      icon = 'ra ra-scroll-unfurled';
      break;
    case 'ethnicity':
      icon = 'ra ra-footprint';
      break;
    case 'location':
      icon = 'ra ra-mountains';
      break;
    case 'item':
      icon = 'ra ra-sword';
      break;
    case 'language':
      icon = 'ra ra-wooden-sign';
      break;
    case 'material':
      icon = 'ra ra-gold-bar';
      break;
    case 'formation':
      icon = 'ra ra-lightning-sword';
      break;
    case 'myth':
      icon = 'ra ra-hydra';
      break;
    case 'law':
      icon = 'ra ra-lightning';
      break;
    case 'plot':
      icon = 'ra ra-meat-hook';
      break;
    case 'profession':
      icon = 'ra ra-gear-hammer';
      break;
    case 'prose':
      icon = 'ra ra-rune-stone';
      break;
    case 'rank':
      icon = 'ra ra-crown';
      break;
    // case 'settlement':
    case 'species':
      icon = 'ra ra-fish';
      break;
    case 'spell':
      icon = 'ra ra-fairy-wand';
      break;
    case 'technology':
      icon = 'ra ra-vial';
      break;
    case 'tradition':
      icon = 'ra ra-two-hearts';
      break;
    case 'vehicle':
      icon = 'ra ra-horseshoe';
      break;
    case 'article':
    case 'generic':
    default:
      icon = 'ra ra-book';
      break;
  }
  let ret = {
    icon: icon && icon.length > 0 ? icon : undefined,
    tooltip: undefined,
  };

  if (options && options.tooltip) {
    ret.tooltip = tooltip;
  }

  return ret;
}
